/**
 * Expansion key for a report row with an individual-tax-lot drill-down.
 *
 * Shared by the two reports that publish per-row `lots` - the Security Cross
 * Reference and Fixed Income Holdings. Both back their rows with a (portfolio,
 * security) pair: one portfolio can emit two rows when two seam-alias security
 * ids share a CUSIP, and an aggregate (@@) run puts many portfolios in one
 * payload, so neither side alone can key the expansion state. `row_key` is the
 * backend's per-row identity; the portfolio_id fallback keeps cached/replayed
 * SCR payloads that predate it working.
 */
export const lotRowKey = (row) => String(row.row_key ?? row.portfolio_id);
